import { Avatar } from '@mui/material'
// import NumberFormat from 'react-number-format'

export const GridMode = ({ item }) => {

    return (
        <div className="row p-contact-grid-mode">
            <div className="col">

                <div className="row photo">
                    <div className="col d-flex justify-content-center">
                        <div className='d-flex justify-content-center align-items-center p-container-foto'>
                            {item.url_foto ?
                                <Avatar
                                    alt={item.nombre}
                                    src={item.url_foto}
                                    sx={{ width: 46, height: 46 }}
                                />
                                :
                                <span>{item.nombre ? item.nombre.substring(0, 2) : ''}</span>
                            }
                        </div>
                    </div>
                </div>

                <div className="row nombre">
                    <div className="col d-flex justify-content-center">
                        {item.nombre ? (item.nombre.length < 30 ? item.nombre : `${item.nombre.substring(0, 27)}...`) : 'sin info'}
                    </div>
                </div>

                <div className="row otros">
                    <div className="col d-flex justify-content-center">
                        {item.email || 'Sin email'}
                    </div>
                </div>

                <div className="row otros">
                    <div className="col d-flex justify-content-center">
                        {item.celular || 'Sin fono'}
                    </div>
                </div>

                <div className="row direccion">
                    <div className="col d-flex justify-content-center">
                        {
                            item.direccion ?
                                (item.direccion?.length <= 50 ? item.direccion : `${item.direccion?.substring(0, 50)}...`)
                                :
                                'Sin dirección'
                        }
                    </div>
                    <br /><br />
                </div>

                <div className="row labels">
                    <div className="col">
                        <label className={`${item.clasificacion}`}>{item.clasificacion || 'Sin info.'}</label>
                    </div>
                </div>

            </div>
        </div>
    )
}